import * as storeActions from '../store/actions';
const claimBonus = storeActions.claimBonus;
const resetClaimError = storeActions.resetBonusClaimStatus;
const getBonusAvailable = storeActions.getBonusAvailable;

export { claimBonus, resetClaimError, getBonusAvailable };
